<script>

import axios from 'axios'

export default {
  props: {
    source: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    collection: "",
    show_last_modification: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      name: window.name,
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      refresh: 60000, 
      columns: [],
      data: [],
      tableData: [],
			totalRows: 1,
			currentPage: 1,
			perPage: 10,
      pageOptions: [10, 25, 50, 100],
			filter: null,
			filterOn: [],
			sortBy: 'incident_id',
			sortDesc: true,
      lastUpdated: '',
      padding_top: '20px',
			isBusy: true,
			fields: [
				{ key: 'severity', sortable: true },
				{ key: 'action_remote_ip', label: "Action Remote IP", sortable: true },
				{ key: 'action_local_ip', label: "Action Local IP", sortable: true },
				{ key: 'host_ip', label: 'Host IP', sortable: true },
				{ key: 'host_name', label: 'Hostname', sortable: true },
        { key: 'user_name', label: 'Username', sortable: true },
				{ key: 'event_type', label: 'Event Type', sortable: true },
				{ key: 'category', label: 'Category', sortable: true },
				{ key: 'action', sortable: true },
				{ key: 'count', label: 'Count', sortable: true },
      ],
      actionData: {
        icons: {
          "Prevented": "uil-shield-check",
          "Detected": "uil-eye"
        },
        classes: {
          "Prevented": "prevented",
          "Detected": "detected"
        },    
      },
    }
  },
  methods: {    
    logsRedirect: function (er, encodedValue, extReference, modalValue, inject=true) {
      libAnatico.logsRedirect(er, 
          encodedValue, 
          extReference, 
          modalValue, 
          true);
    },
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
    showModal: function (name, value) {
      libModal.showModal(name, value);
    },
    modalName(name, value) {
      return libModal.modalName(name, value);
    },
    imageName: function (column, value) {
      return `${column.path}/${value}.${column.extension}`;
    },
    numeralFormat: function (number) {
      return number
      // return numeral(number).format('0,0');
    },
    getReference (ref, mods) {
      if (mods !== undefined && mods.includes('first_word')) {
        ref = ref.split(" ")[0] || ""
      } 
      if (mods !== undefined && mods.includes('cast_date')) {
        ref = new Date(ref).toLocaleString()
      }
       if (mods !== undefined && mods.includes('cut_10')) {
        ref = new Date(ref).toLocaleString()
      }
      if (mods !== undefined && mods.includes('no_text')) {
        ref = ""
      }
      return ref
    },
    getClasses (clss, ref, mods) {
      if (clss === undefined) return ref
      if (mods !== undefined && mods.includes('first_word')) {
        ref = ref.split(" ")[0] || ""
      } 
      return clss[ref] 
    },
    getIcons (icons, ref, mods) {
      if (icons === undefined) return
      if (mods.includes('first_word')) {
        ref = ref.split(" ")[0]
      } 
      return icons[ref]
    },
    getData: function () {
      let that = this;
      if (that.show_last_modification){
        that.padding_top= '0px';
      }
      if (that.source === undefined) {
        console.error('TopAlerts Error - Source file not defined in component.');
        return
      }
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'

      axios
      .get(baseURL + that.source)
      .then(function (response) {
          if (response.status === 200) {
            if (response.data.data === undefined || response.data.updated === undefined) {
              console.error('TopAlerts Error - data not defined in source file.')
              return
            }
            that.tableData = response.data.data
            that.totalRows = that.tableData.length
            that.lastUpdated = new Date(response.data.updated).toLocaleString()
            that.isBusy = false
          }
          else if (response.status === 404) {
            console.error('TopAlerts Error - Source file not found.');
            return
          }
      })
			.catch(function (error) {
        console.error('Error loading TopAlerts data. Error:', error.response);
				if (error.response.status === 401 || error.response.status === 403) {
					localStorage.removeItem('idToken')
					that.$router.push({ name: 'Home' })
				}
			}) 
    }
  },
	computed: {
		rows() {
			return this.tableData.length
		},
	},
  created: function() {
    this.getData()
  }
}
</script>

<template>
  <div>
		<div class="row mb-md-2" style="padding:10px">
			<div class="col-sm-6 col-md-6" style="text-align:left !important">
				<span>
					Grouped Alerts in last 24h: 
					<b>
						{{ totalRows }}
					</b>
          &nbsp;-&nbsp;
					Last updated at
					<b>
						{{ lastUpdated }}
					</b>
				</span>
			</div>

			<div class="col-sm-6 col-md-6">
				<div
					id="tickets-table_filter"
					class="dataTables_filter text-md-right"
				>
					<label class="d-inline-flex align-items-center">
						Search:
						<b-form-input
							v-model="filter"
							type="search"
							placeholder="Search..."
							class="form-control form-control-sm ml-2"
						></b-form-input>
					</label>
				</div>
			</div>
		</div>
		<div class="table-responsive mb-0">
			<b-table
				:items="tableData"
				:fields="fields"
				:busy="isBusy"
				responsive="sm"
				:per-page="perPage"
				:current-page="currentPage"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:filter="filter"
				:filter-included-fields="filterOn"
				@filtered="onFiltered"
        small
			>
				<template v-slot:table-busy>
					<div class="text-center">
					<br><br>
					<b-spinner class="align-middle"></b-spinner>
					<strong>&nbsp;&nbsp;Loading...</strong>
					</div>
				</template>

				<template v-slot:cell(severity)="data">
					<template v-if="data.item.severity === 'low'">
						<feather type="alert-circle" class="icon-xs icon-dual-success"></feather>
					</template>
					<template v-else-if="data.item.severity === 'medium'">
						<feather type="alert-triangle" class="icon-xs icon-dual-warning"></feather>
					</template>
					<template v-else>
						<feather type="alert-octagon" class="icon-xs icon-dual-danger"></feather>
					</template>
				</template>

        <template v-slot:cell(action_remote_ip)="data">
            {{ data.value }}
        </template>

        <template v-slot:cell(action_local_ip)="data">
            {{ data.value }}
        </template>

        <template v-slot:cell(host_ip)="data">
            {{ data.value }}
        </template>

        <template v-slot:cell(host_name)="data">
            {{ getReference(data.value, []) }}
        </template>

        <template v-slot:cell(event_type)="data">
            {{ getReference(data.value, []) }}
        </template>

        <template v-slot:cell(category)="data">
            {{ getReference(data.value, []) }}
        </template>

        <template v-slot:cell(action)="data">
          <span :class="actionData.classes[getReference(data.value, ['first_word'])]">
      			<i class="uil" :class="actionData.icons[getReference(data.value, ['first_word'])]" />&nbsp;
            {{ getReference(data.value, ["first_word"]) }}
          </span>
        </template>
			</b-table>
		</div>
		<div class="row">
			<div class="col-sm-6 col-md-6" style="text-align:left !important">
				<div id="tickets-table_length" class="dataTables_length">

					<label class="d-inline-flex align-items-center">
						&nbsp;&nbsp;Show&nbsp;
						<b-form-select
							v-model="perPage"
							size="sm"
							:options="pageOptions"
						></b-form-select
						>&nbsp;entries
					</label>
				</div>
			</div>
			<div class="col-sm-6 col-md-6">
				<div
					class="dataTables_paginate paging_simple_numbers float-right"
				>
					<ul class="pagination mb-1 mr-2">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
              size="sm"
						></b-pagination>
					</ul>
				</div>
			</div>
		</div>
  </div>
  </div>
</template>


<style>
  .mc_table {
    width: 100%;
    border: 1px;
    border-color: black;
    line-height: 20px !important;
  }

  .mc_table tr{
    height: 20px !important;
  }

  .normal {
    color: #D7DBE2;
    fill: #D7DBE2;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }

  .normal {
    color: #D7DBE2;
    fill: #D7DBE2;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }
  
  .high {
    color: #DC001E;
    fill: #DC001E;
    background-color: #DC001E !important;
    border: 0px !important;  
  }

  .medium {
    color: #FECA00;
    fill: #FECA00;
    background-color: #FECA00 !important;
    border: 0px !important;  
  }

  .low {
    color: #01AD00;
    fill: #01AD00;
    background-color: #01AD00 !important;
    border: 0px !important;  
  }

 .severity_high1 {
    color: #fff;
    fill: #DC001E;
    background-color: #DC001E !important;
    border: 0px !important;
    padding: 2px;
  }

 .severity_high {
    color: #DC001E;
  }

  .severity_medium {
    color: #FECA00;
  }

  .severity_low {
    color: #01AD00;
  }

  .prevented {
    color: #01AD00;
  }

  .detected {
    color: rgb(26, 5, 214);
  }

  .light {
    color: rgb(200, 200, 200);
  }

  .reference {
    font-family: "Nunito Sans", sans-serif;
    font-size:0.95em;
  }

  .value {
    font-family: "Nunito Sans", sans-serif;
    font-size:0.95em;
  }

  .tleft {
    text-align: left;
    vertical-align: middle;
  }

  .tcenter {
    text-align: center;
    vertical-align: middle;
  }

  .tarow {
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: #e9e9e9;
  }
</style>
